var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-campaign-filters-bar bb-description-4 bb-row-to-column-sm"},[(_vm.appliedFilter.filter)?_c('span',{staticClass:"bb-text-primary bb-bold",on:{"click":_vm.clearFilter}},[_vm._v("\n        Limpiar filtros\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }